export default __webpack_public_path__ + "static/media/caret-down.e2abcff2.svg";